import { render } from "./DefaultFooter.vue?vue&type=template&id=1da2e4e3"
const script = {}

import exportComponent from "/home/astaguna/Documents/dct/transferapproval/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__